import cssVars from 'css-vars-ponyfill';

cssVars({
  // Targets
  rootElement: document,
  shadowDOM: false,

  // Sources
  include: 'link[rel=stylesheet],style',

  // Options
  onlyLegacy: true,
  preserveStatic: true,
  preserveVars: true,
  silent: true,
  updateDOM: true,
  updateURLs: true,
});
